
import {profitDataMonthDay,profitDataMonthDayExport} from "@/api/http";

const columnList: Array<column> = [
    {
        prop: "settlement_time",
        label: "结算日期",
        width: 120,
    },
    {
        prop: "ordersn",
        label: "工单号",
        width: 120,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 60,
    },
    {
        prop: "car_model",
        label: "车型",
        width: 75,
    },
    {
        prop: "phone",
        label: "手机号",
        width: 60,
    },
    {
        prop: "check_out",
        label: "已出车/未出车",
        width: 75,
    },
    {
        prop: "is_group",
        label: "是否建群",
        width: 60,
    },
    {
        prop: "basicset_name",
        label: "服务类型",
        width: 60,
    },
    {
        prop: "insurance_name",
        label: "保险公司",
        width: 75,
    },
    {
        prop: "assessment_money",
        label: "定损金额",
        width: 60,
    },
    {
        prop: "self_money",
        label: "自费金额",
        width: 60,
    },
    {
        prop: "number_turnover",
        label: "产值",
        width: 60,
    },
    {
        prop: "self_parts_cost",
        label: "自采配件成本",
        width: 60,
    },
    {
        prop: "direct_supply",
        label: "是否直供配件（是/否）",
        width: 60,
    },
    {
        prop: "direct_supply_cost",
        label: "直供配件成本",
        width: 60,
    },
    {
        prop: "return_cost",
        label: "退货成本",
        width: 60,
    },
    {
        prop: "paint_number",
        label: "油漆付数",
        width: 60,
    },
    {
        prop: "paint_cost",
        label: "油漆成本",
        width: 60,
    },
    {
        prop: "processing_costs",
        label: "维修外加工费用",
        width: 60,
    },
    {
        prop: "recycle_cost",
        label: "回收成本",
        width: 60,
    },
    {
        prop: "other_name",
        label: "其它费用项目名称",
        width: 60,
    },
    {
        prop: "other_money",
        label: "其它费用项目金额",
        width: 60,
    },
    {
        prop: "business_money",
        label: "车主业务费用金额",
        width: 60,
    },
    {
        prop: "parts_cost",
        label: "配件成本",
        width: 60,
    },
    {
        prop: "total_cost",
        label: "总成本",
        width: 60,
    },
    {
        prop: "gross_margin",
        label: "本车毛利",
        width: 60,
    },
    {
        prop: "gross_margin_rate",
        label: "毛利率",
        width: 60,
    },
    {
        prop: "salesman",
        label: "业务员",
        width: 60,
    },
    {
        prop: "salesman_money",
        label: "业务员提成",
        width: 60,
    },
    {
        prop: "recommend_name",
        label: "推修人",
        width: 60,
    },
    {
        prop: "recommend_money",
        label: "推修人提成",
        width: 60,
    },
    {
        prop: "metal_cost",
        label: "油漆/钣金人工成本",
        width: 60,
    },
    {
        prop: "machine_cost",
        label: "机修人工成本",
        width: 60,
    },
    {
        prop: "gross_margin_desc",
        label: "毛利说明",
        width: 60,
    },
    {
        prop: "save_parts_detail",
        label: "节约配件明细",
        width: 60,
    },
    {
        prop: "save_parts_cost",
        label: "节约配件成本",
        width: 60,
    },
    {
        prop: "day_output",
        label: "当日总产值",
        width: 60,
    },
    {
        prop: "gross_margin_desc",
        label: "备注(客户投诉及返工记录)",
        width: 60,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted
} from "vue";
import {dateformat, getFirstNowLastDay} from "@/api/date" ;
import {Request} from '@/api/request';
import { column } from "@/assets/types/common";
import {useRoute, useRouter} from "vue-router";
export default defineComponent({
    name: "businessSummaryDetail",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['利润统计']);
        
        const headClass = inject("headClass");
        const Router = useRouter();
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            tableData = ref([] as any),
            
            loading = ref(false),
            getFirstNowLastDay = ():number => {
                let now = new Date();
                let strLink = "-";
                let year = now.getFullYear();
                let month:any = now.getMonth() + 1;
                let day:any = now.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 1 && day <= 9) {
                    day = "0" + day;
                }
                let firstDate:string = year + strLink + month + strLink + day;
                let currentDate = year + strLink + month;
                return new Date(firstDate).getTime();
            },
            params = reactive({
                dayTime: getFirstNowLastDay(),
                monthTime: getFirstNowLastDay(),
                type:1
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            screenChange = (e: string | Array < any > , key: any): void => {
                // let monthTime = Math.floor(new Date(params.time).getTime()/1000)
                // console.log(monthTime);
                initData();
            },
            typeChange = ()=>{
                initData();
            },
            initData = ()=>{
                currentPage.value = 1;
                getTableData();
            },
            exportChange = ()=>{
                let monthTime = Math.floor(new Date(params.monthTime).getTime()/1000)
                let dayTime = Math.floor(new Date(params.dayTime).getTime()/1000)
                let data = {
                    "monthTime":monthTime,
                    "dayTime":dayTime,
                    "type":params.type,
                }
                loading.value = true;
                profitDataMonthDayExport(data).then((res:any)=>{
                    console.log(res);
                    loading.value = false;
                    //tableData.value = res.content.list;
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                });
            },
            getTableData = (): void => {
                //params.start_time = params.time?Math.floor(new Date(params.time[0]).getTime()/1000):0;
                //params.end_time = params.time ?Math.floor((new Date(params.time[1]).getTime()+24*60*60*1000-1)/1000):0;
                let monthTime = Math.floor(new Date(params.monthTime).getTime()/1000)
                let dayTime = Math.floor(new Date(params.dayTime).getTime()/1000)
                let data = {
                    "monthTime":monthTime,
                    "dayTime":dayTime,
                    "type":params.type,
                    "limit":pageSize.value,
                    "page":currentPage.value
                }
                loading.value = true;
                profitDataMonthDay(data).then((res:any)=>{
                    console.log(res);
                    loading.value = false;
                    tableData.value = res.content.list;
                    total.value = res?.content?.total || 0;
                });
                
            }
        onMounted(() => {
            getTableData();
        });
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            loading,
            handleSizeChange,
            handleCurrentChange,
            params,
            exportChange,
            total,
            typeChange,
            screenChange,
        };
    },
});
